var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.config && _vm.config.login)?_c('HookCustom',{attrs:{"componente":_vm.config.login},on:{"loginsuccess":_vm.getDatosUsuario}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }